__turbopack_context__.v({
  "descriptionText": "styles-module__GrYnUa__descriptionText",
  "desktopImage": "styles-module__GrYnUa__desktopImage",
  "featuredImageContainer": "styles-module__GrYnUa__featuredImageContainer",
  "mobileImage": "styles-module__GrYnUa__mobileImage",
});
